module.exports = __webpack_public_path__ + "img/login_cover.129ef2f4.jpg";